import { FilterKeys, Filters } from '@utils/pageConfig/Types';
import { byFilterKey, excludeByFilterKey } from '@utils/pageConfig/Predicates/SelectedFiltersPredicates';
import { isLocalCurrencyApplied } from '@utils/currencyUtils/CurrencyUtils';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import { isMultiPgCommonFeatureAllowed } from '@utils/filterTrayUtils/FilterTrayUtils';

export const getFilteredFeatureValues = (
  currentFeatureValues: Filters[],
  pagesConfig: PagesConfig,
  effectiveProductType: any,
): Filters[] => {
  const { pageType, appliedFilters } = pagesConfig;
  const currentlyAppliedFilters = appliedFilters[pageType].selectedFilters;

  const currentlyAppliedCountries = currentlyAppliedFilters.find(byFilterKey(FilterKeys.COUNTRY));
  const currentlyAppliedProductGroups = currentlyAppliedFilters.find(byFilterKey(FilterKeys.PRODUCT_GROUP));
  const currentlyAppliedCurrency = currentlyAppliedFilters.find(byFilterKey(FilterKeys.CURRENCY));
  const hasSingleProductGroup = currentlyAppliedProductGroups?.options.length === 1;
  const hasMultipleProductGroup = currentlyAppliedProductGroups
    ? currentlyAppliedProductGroups.options.length >= 2
    : false;
  const hasMultipleCountries = currentlyAppliedCountries?.options && currentlyAppliedCountries?.options.length > 1;
  let newFeatureValues = currentFeatureValues;

  if (hasSingleProductGroup || hasMultipleCountries) {
    newFeatureValues = newFeatureValues.filter(excludeByFilterKey(FilterKeys.CATEGORY));
  }

  if ((hasSingleProductGroup && !hasMultipleCountries) || !hasSingleProductGroup) {
    newFeatureValues = newFeatureValues.filter(excludeByFilterKey(FilterKeys.COUNTRIES_FEATURE));
  }

  if (
    !currentlyAppliedCurrency ||
    !currentlyAppliedCountries ||
    isLocalCurrencyApplied(pagesConfig, effectiveProductType, currentlyAppliedCurrency, currentlyAppliedCountries)
  ) {
    if (hasMultipleCountries) {
      newFeatureValues = newFeatureValues.filter(excludeByFilterKey(FilterKeys.PRICEBAND));
    }
  }
  if (hasMultipleProductGroup && pagesConfig.pageName && !isMultiPgCommonFeatureAllowed(pagesConfig.pageType)) {
    newFeatureValues = newFeatureValues.filter(excludeByFilterKey(FilterKeys.SEGFEAT));
    newFeatureValues = newFeatureValues.filter(excludeByFilterKey(FilterKeys.ADDFEAT));
  }

  return newFeatureValues;
};
